module.exports = __webpack_public_path__ + "img/solarstand.0333e20a.svg";